/* Flora Bespoke Builder (v2.5)

   Drives the guided brief on /pages/design-your-piece:
   one question per screen, a live preview of real matching pieces, and a live
   price range. Everything degrades: with this file blocked the steps render
   stacked, four fallback photos show, and the form still posts.

   The photo library is assets/flora-bespoke-photos.json. Adding a photo there
   extends coverage with no change to this file or to the section.

   v2.4: a step can now hold more than one required group without the error
   line firing early. See the note in the click handler.

   v2.5 (2026-07-30): the commission tile. Her own photos cover 28 of the 60
   style/colour/size combinations, so a visitor picking one of the other 32 saw
   four photos that did not answer their brief. When a combination has NO real
   photo behind it, the fourth tile becomes a sourced photograph of a similar
   look from assets/flora-bespoke-backfill.json, carrying a visible label, and
   the panel's label and note change to say what it is. Her photos always lead:
   the tile only appears when nothing in the library matches style, palette and
   scale, and it never replaces more than the weakest of the four slots. The
   remaining combinations have no honest match and deliberately show nothing
   extra. If the sourced image fails to load the tile removes itself and the
   copy reverts, so a dead hotlink degrades to the old behaviour. */

(function () {
  var root = document.querySelector('[data-flora-builder]');
  if (!root) return;
  var form = root.querySelector('form');
  if (!form) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  if (!steps.length) return;

  var pips = Array.prototype.slice.call(root.querySelectorAll('[data-pip]'));
  var count = root.querySelector('[data-count]');
  var backBtn = root.querySelector('[data-back]');
  var nextBtn = root.querySelector('[data-next]');
  var summary = root.querySelector('[data-summary]');
  var priceEl = root.querySelector('[data-price]');
  var priceInput = root.querySelector('[data-price-input]');
  var grid = root.querySelector('[data-preview-grid]');
  var label = root.querySelector('[data-preview-label]');
  var note = root.querySelector('[data-preview-note]');

  var index = 0;
  var picks = {};
  var photos = [];
  var base = '';
  var looks = {};
  var lookLabel = 'A look you can commission';
  var photoState = 'default';

  root.setAttribute('data-js', 'true');

  /* ---------------------------------------------------------------- price */
  /* Derived from live store pricing plus the custom floor in the brand notes,
     and signed off by Kaili in APPROVALS A21. Low and high move separately,
     then the pair is rounded outward to the nearest $50. FLOOR_PRICE keeps the
     range honest against the custom starting point, so the cheapest
     combination never quotes like a ready made bowl. */
  var BASE = { tabletop: [500, 750], statement: [750, 1200], floor: [1200, 2000] };
  var STYLE = { classic: [0, 0], 'wild-organic': [0, 100], sculptural: [50, 150], 'minimal-green': [-100, -150] };
  var POT = { bowl: [0, 0], vase: [0, 0], planter: [50, 100], urn: [75, 150] };
  var OWN_POT = [-100, -150];
  var FLOOR_PRICE = 450;

  function money(value) {
    var digits = String(value);
    var out = '';
    for (var i = 0; i < digits.length; i++) {
      if (i > 0 && (digits.length - i) % 3 === 0) out += ',';
      out += digits.charAt(i);
    }
    return '$' + out;
  }

  function priceRange() {
    if (!picks.scale || !BASE[picks.scale]) return null;
    var low = BASE[picks.scale][0];
    var high = BASE[picks.scale][1];
    var style = STYLE[picks.style];
    if (style) { low += style[0]; high += style[1]; }
    var pot = POT[picks.container];
    if (pot) { low += pot[0]; high += pot[1]; }
    if (picks.sourcing === 'own') { low += OWN_POT[0]; high += OWN_POT[1]; }
    low = Math.max(FLOOR_PRICE, Math.floor(low / 50) * 50);
    high = Math.ceil(high / 50) * 50;
    if (high < low + 150) high = low + 150;
    return money(low) + ' to ' + money(high);
  }

  function renderPrice() {
    var value = priceRange();
    if (priceEl) priceEl.textContent = value || priceEl.getAttribute('data-default') || '';
    if (priceInput) priceInput.value = value || priceInput.defaultValue || '';
  }

  /* -------------------------------------------------------------- preview */
  /* Style matters most, then colour, then the pot and the size. Room is a
     nudge only, because most photos do not read as one specific room. */
  var WEIGHT = { style: 4, palette: 3, container: 2, scale: 2, room: 1 };

  function bestPhotos() {
    var keys = Object.keys(WEIGHT).filter(function (key) { return picks[key]; });
    if (!keys.length) return { list: photos.slice(0, 4), state: 'default' };
    var max = 0;
    keys.forEach(function (key) { max += WEIGHT[key]; });
    var scored = photos.map(function (photo) {
      var score = 0;
      keys.forEach(function (key) { if (photo[key] === picks[key]) score += WEIGHT[key]; });
      return { photo: photo, score: score };
    });
    scored.sort(function (a, b) { return (b.score - a.score) || (b.photo.q - a.photo.q); });
    return {
      list: scored.slice(0, 4).map(function (entry) { return entry.photo; }),
      state: scored[0].score === max ? 'exact' : 'close'
    };
  }

  /* A combination counts as covered the moment ONE real photo shares its
     style, palette and scale. Pot and room are deliberately left out: they
     vary within a look, and requiring them would push the commission tile in
     front of pieces Kaili has genuinely made. */
  function commissionLook() {
    if (!picks.style || !picks.palette || !picks.scale) return null;
    var look = looks[picks.style + '|' + picks.palette + '|' + picks.scale];
    if (!look || !look.img) return null;
    var made = photos.some(function (photo) {
      return photo.style === picks.style && photo.palette === picks.palette && photo.scale === picks.scale;
    });
    return made ? null : look;
  }

  function applyCopy(state) {
    if (label) {
      var labelText = label.getAttribute('data-label-' + state);
      if (labelText) label.textContent = labelText;
    }
    if (note) {
      var noteText = note.getAttribute('data-note-' + state) || note.getAttribute('data-note-default');
      if (noteText) note.textContent = noteText;
    }
  }

  /* The sourced photo is hotlinked from Pexels, which serves resized copies
     from query parameters. Eager, like its neighbours: this grid builds its
     images in script after first paint, and Chrome does not reliably start a
     lazy load for one of those, which is what left the panel showing empty
     boxes before. All four tiles sit in the viewport on both layouts. */
  function buildLookTile(look) {
    var figure = document.createElement('figure');
    figure.className = 'flora-builder__preview-look';
    var joiner = look.img.indexOf('?') === -1 ? '?' : '&';
    function sized(width) {
      return look.img + joiner + 'auto=compress&cs=tinysrgb&fit=crop&w=' + width + '&h=' + width;
    }
    var img = document.createElement('img');
    img.className = 'flora-builder__preview-img';
    img.loading = 'eager';
    img.decoding = 'async';
    if ('fetchPriority' in img) img.fetchPriority = 'low';
    img.alt = look.alt || 'A similar look you can commission';
    img.width = 480;
    img.height = 480;
    img.srcset = sized(360) + ' 360w, ' + sized(480) + ' 480w, ' + sized(720) + ' 720w';
    img.sizes = '(min-width: 1000px) 9rem, 42vw';
    img.src = sized(480);
    img.addEventListener('error', function () {
      figure.style.display = 'none';
      applyCopy(photoState);
    });
    var tag = document.createElement('figcaption');
    tag.className = 'flora-builder__preview-tag';
    tag.textContent = lookLabel;
    figure.appendChild(img);
    figure.appendChild(tag);
    return figure;
  }

  /* Note: these images are the point of the panel and they sit in the
     viewport on both layouts, so they load eagerly. Chrome does not reliably
     start a lazy load for an img element that is built in script and inserted
     after first paint, which left the panel showing four empty boxes. */
  function renderPreview() {
    if (!grid || !photos.length) return;
    var result = bestPhotos();
    if (!result.list.length) return;
    photoState = result.state;
    var look = commissionLook();
    var list = look ? result.list.slice(0, 3) : result.list;
    var frag = document.createDocumentFragment();
    list.forEach(function (photo) {
      var url = base + photo.src;
      var img = document.createElement('img');
      img.className = 'flora-builder__preview-img';
      img.loading = 'eager';
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.alt = photo.alt || 'A finished Flora piece in a client home';
      img.width = photo.w;
      img.height = photo.h;
      img.srcset = url + '?width=360 360w, ' + url + '?width=480 480w, ' + url + '?width=720 720w';
      img.sizes = '(min-width: 1000px) 9rem, 42vw';
      img.src = url + '?width=480';
      frag.appendChild(img);
    });
    if (look) frag.appendChild(buildLookTile(look));
    grid.innerHTML = '';
    grid.appendChild(frag);
    applyCopy(look ? 'commission' : result.state);
  }

  var manifestUrl = root.getAttribute('data-manifest');
  if (manifestUrl && window.fetch) {
    fetch(manifestUrl, { credentials: 'omit' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.photos || !data.photos.length) return;
        base = data.base || '';
        photos = data.photos;
        renderPreview();
      })
      .catch(function () { /* the Liquid fallback photos stay in place */ });
  }

  var backfillUrl = root.getAttribute('data-backfill');
  if (backfillUrl && window.fetch) {
    fetch(backfillUrl, { credentials: 'omit' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.looks) return;
        looks = data.looks;
        if (data.label) lookLabel = data.label;
        renderPreview();
      })
      .catch(function () { /* no commission tile, her own photos still show */ });
  }

  /* ---------------------------------------------------------------- steps */
  function render() {
    steps.forEach(function (step, i) {
      step.setAttribute('data-active', i === index ? 'true' : 'false');
    });
    pips.forEach(function (pip, i) {
      pip.setAttribute('data-state', i < index ? 'done' : (i === index ? 'current' : 'todo'));
    });
    if (count) count.textContent = (index + 1) + ' of ' + steps.length;
    if (backBtn) backBtn.setAttribute('data-visible', index > 0 ? 'true' : 'false');
    root.setAttribute('data-last', index === steps.length - 1 ? 'true' : 'false');
  }

  function groupsIn(step) {
    return Array.prototype.slice.call(step.querySelectorAll('[data-group]'));
  }

  function inputFor(group) {
    return root.querySelector('[data-input="' + group.getAttribute('data-group') + '"]');
  }

  function validate(step) {
    var ok = true;
    groupsIn(step).forEach(function (group) {
      if (group.getAttribute('data-required') !== 'true') return;
      var input = inputFor(group);
      if (!input || !input.value.trim()) ok = false;
    });
    var error = step.querySelector('[data-error]');
    if (error) error.hidden = ok;
    return ok;
  }

  root.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-value]') : null;
    if (!btn || !root.contains(btn)) return;
    var group = btn.closest('[data-group]');
    if (!group) return;

    Array.prototype.slice.call(group.querySelectorAll('[data-value]')).forEach(function (other) {
      other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
    });

    var input = inputFor(group);
    if (input) input.value = btn.getAttribute('data-value') || '';

    var facet = group.getAttribute('data-facet');
    if (facet) {
      var tag = btn.getAttribute('data-tag') || '';
      if (tag) { picks[facet] = tag; } else { delete picks[facet]; }
    }

    /* Only re-check a step whose error line is already showing. The step with
       two questions on it would otherwise flash an error for the first one the
       moment someone answers the second. Errors still appear on Next and on
       submit, which is the only place they are useful. */
    var step = btn.closest('[data-step]');
    if (step) {
      var stepError = step.querySelector('[data-error]');
      if (!stepError || stepError.hidden === false) validate(step);
    }

    renderPreview();
    renderPrice();
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (!validate(steps[index])) return;
      if (index < steps.length - 1) {
        index += 1;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (index > 0) {
        index -= 1;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  form.addEventListener('submit', function (event) {
    var firstInvalid = -1;
    steps.forEach(function (step, i) {
      if (firstInvalid === -1 && !validate(step)) firstInvalid = i;
    });
    if (firstInvalid !== -1) {
      event.preventDefault();
      index = firstInvalid;
      render();
      return;
    }
    if (!summary) return;
    var lines = ['Bespoke brief', ''];
    steps.forEach(function (step) {
      groupsIn(step).forEach(function (group) {
        var input = inputFor(group);
        if (input && input.value.trim()) {
          lines.push(group.getAttribute('data-group') + ': ' + input.value.trim());
        }
      });
      var fields = step.querySelectorAll('textarea:not([data-summary]), input[type="text"], input[type="tel"], input[type="email"]');
      Array.prototype.slice.call(fields).forEach(function (field) {
        if (!field.value.trim()) return;
        var labelEl = field.parentElement ? field.parentElement.querySelector('label') : null;
        var name = labelEl ? labelEl.textContent.trim() : field.name;
        lines.push(name + ': ' + field.value.trim());
      });
    });
    lines.push('');
    lines.push('Range shown on the page: ' + (priceInput ? priceInput.value : ''));
    summary.value = lines.join('\n');
  });

  render();
  renderPrice();
})();
